import axios from "axios";
import { apiURL } from "../../utils/config";

const axiosAPI = axios.create({
  baseURL: apiURL,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: (params) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          if (v !== undefined) searchParams.append(key, v);
        });
      } else if (value !== undefined) {
        searchParams.append(key, value);
      }
    });
    return searchParams.toString();
  },
});
axiosAPI.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken"); // sessionStorage.getItem("jwt");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete axiosAPI.defaults.headers.common.Authorization;
    }
    return config;
  },

  (error) => Promise.reject(error)
);

export default axiosAPI;
